import { cn } from "@/utilities/cn";
import { HTMLProps } from "react";

interface SectionProps extends HTMLProps<HTMLDivElement>{}

export default function Section({className, ...props}: SectionProps){
    return <section className={cn("py-16 md:py-24 flex flex-col", className)} {...props}>

    </section>
}